import React, { useState } from 'react';
import { Home } from 'lucide-react';

export default function ImageGallery({ images, title, totalDiscount }) {
  const [selected, setSelected] = useState(0);
  const hasImages = images && images.length > 0;

  return (
    <div className="space-y-3 sm:space-y-4">
      <div className="relative h-64 sm:h-96 lg:h-[500px] rounded-2xl overflow-hidden bg-muted">
        {hasImages ? (
          <img src={images[selected]} alt={title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center"><Home className="w-20 h-20 text-muted-foreground" /></div>
        )}
        {totalDiscount > 0 && (
          <div className="absolute top-4 left-4 sm:top-6 sm:left-6 bg-accent text-accent-foreground px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-bold tracking-wide">
            {totalDiscount.toFixed(0)}% OFF
          </div>
        )}
      </div>
      {hasImages && images.length > 1 && (
        <div className="grid grid-cols-4 gap-2 sm:gap-4">
          {images.map((img, idx) => (
            <div
              key={`${img}-${idx}`}
              data-testid={`thumbnail-${idx}`}
              onClick={() => setSelected(idx)}
              className={`h-16 sm:h-24 rounded-lg overflow-hidden cursor-pointer border-2 ${selected === idx ? 'border-primary' : 'border-transparent'}`}
            >
              <img src={img} alt={`Thumbnail ${idx + 1}`} className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
